<template>
  <el-tooltip
    popper-class="popper"
    :content="content || text"
    :disabled="showTooltip"
    :placement="placement"
    :show-arrow="false"
  >
    <template #content>
      <span v-if="content || text">{{ content || text }}</span>
      <span v-else><slot></slot></span>
    </template>
    <div
      class="text-ellipsis-multiple"
      :style="styleObj"
      @mouseenter.stop="onMouseEnter"
      @click="Details(id)"
      :id="!showTooltip ? 'text' : ''"
    >
      <slot>{{ text }}</slot>
    </div>
  </el-tooltip>
</template>

<script setup>
import { ref, defineProps, computed } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();

const props = defineProps({
  text: String,
  placement: {
    type: String,
    default: "top",
  },
  id: {
    type: String,
    default: "",
  },
  content: String,
  //默认超出一行省略
  lineNumber: {
    type: Number,
    default: 1,
  },
});
let styleObj = computed(() => {
  return { "-webkit-line-clamp": props.lineNumber };
});

let showTooltip = ref(true);

function Details(id) {
  // 这里是您的点击事件处理逻辑
  if (id) {
    router.push({
      path: "/ShadowComposerHomepage",
      query: { id: id },
    });
  }
  console.log("Clicked!");
  // 如果需要传递参数，请修改此函数以接收参数
}
function onMouseEnter(e) {
  const dom = e.target;
  showTooltip.value = !(
    dom.offsetWidth < dom.scrollWidth || dom.offsetHeight < dom.scrollHeight
  );
}
</script>

<style lang="less" scoped>
.text-ellipsis-multiple {
  font-size: 12px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
#text:hover {
  cursor: pointer;
}
</style>
